
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"68","height":"68"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('filter',{attrs:{"id":"a","x":"0","y":"0","width":"68","height":"68","filterUnits":"userSpaceOnUse"}},[_c('feOffset'),_c('feGaussianBlur',{attrs:{"stdDeviation":"2","result":"blur"}}),_c('feFlood',{attrs:{"flood-opacity":".161"}}),_c('feComposite',{attrs:{"operator":"in","in2":"blur"}}),_c('feComposite',{attrs:{"in":"SourceGraphic"}})])]),_c('g',{attrs:{"data-name":"그룹 2043"}},[_c('g',{attrs:{"filter":"url(#a)"}},[_c('circle',{attrs:{"data-name":"타원 255","cx":"28","cy":"28","r":"28","transform":"translate(6 6)","fill":"#f36628"}})]),_c('path',{attrs:{"data-name":"Icon material-edit","d":"M22 41.004v5h5l14.744-14.748-5-5zM45.61 27.39a1.328 1.328 0 000-1.88l-3.12-3.12a1.328 1.328 0 00-1.88 0l-2.44 2.44 5 5 2.44-2.44z","fill":"#fff"}})])])
          )
        }
      }
    